module.exports = __webpack_public_path__ + "img/student.be265189.svg";